import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IAuthState {
  token: string | null
  expirationTime: string | null
  role: string | null
}

const initialState: IAuthState = {
  token: null,
  expirationTime: null,
  role: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokenAndRole: (state, action: PayloadAction<{ token: string; expirationTime: string; role: string | null }>) => {
      state.token = action.payload.token
      state.expirationTime = action.payload.expirationTime
      state.role = action.payload.role
    },
    setToken: (state, action: PayloadAction<{ token: string; expirationTime: string }>) => {
      state.token = action.payload.token
      state.expirationTime = action.payload.expirationTime
    },
    clearToken: () => {
      return {
        ...initialState
      }
    }
  }
})

export const { setToken, setTokenAndRole, clearToken } = authSlice.actions
export const authReducer = authSlice.reducer
